/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ui from 'redux-fui';
import { compose } from 'ramda';
import ScrollLock from 'react-scrolllock';
import GeminiScrollbar from 'react-gemini-scrollbar';
import ProfileImage from '../Common/ProfileImage';
import LegacyLink from '../Common/LegacyLink';
import Logo from '../../../static/images/header_logo.svg';
import LogoSmall from '../../../static/images/header_logo_small.svg';
import withAnalytics from '../Decorators/withAnalytics';
import EnabledFeature from '../Decorators/enabledFeature';

const PrimaryNav = ({ showSearchLink }) => (
  <ul className="c-header__menu">
    {showSearchLink && [
      <li className="mobile-hidden">
        <Link to="/">Search</Link>
      </li>
    ]}
    <li className="mobile-hidden">
      <LegacyLink to="about/">About</LegacyLink>
    </li>
    <EnabledFeature name="primary_header_invest_link">
      <li className="mobile-hidden">
        <LegacyLink to="about/invest/">Invest</LegacyLink>
      </li>
    </EnabledFeature>
    <li className="mobile-hidden">
      <LegacyLink to="rent-out-a-parking-space/">
        Rent out your driveway
      </LegacyLink>
    </li>
    <li className="mobile-hidden">
      <LegacyLink to="car-park-management/">Car park management</LegacyLink>
    </li>
    <li className="mobile-hidden">
      <a href="https://help.justpark.com">Help</a>
    </li>
  </ul>
);

const SecondaryNav = ({ secondaryClass, isAdmin, user }) => (
  <ul className={`${secondaryClass} c-header__menu--secondary`}>
    {isAdmin && [
      <li key="su">
        <LegacyLink to="admin/su/">SU</LegacyLink>
      </li>,
      <li key="admin">
        <LegacyLink to="admin/">Admin</LegacyLink>
      </li>
    ]}
    {user && [
      <li key="dashboard1" className="mobile-hidden">
        <LegacyLink to="dashboard/">Dashboard</LegacyLink>
      </li>,
      <li key="dashboard2" className="desktop-hidden">
        <LegacyLink to="dashboard/">My Dashboard</LegacyLink>
      </li>,
      <li key="bookings">
        <LegacyLink to="dashboard/bookings/">Bookings</LegacyLink>
      </li>,
      <li key="messages">
        <LegacyLink to="dashboard/messaging/">
          Messages
          {user.unreadMessages > 0 && <div>{user.unreadMessages}</div>}
        </LegacyLink>
      </li>,
      <li key="howitworks" className="desktop-hidden">
        <LegacyLink to="about/how-it-works/">How it works</LegacyLink>
      </li>,
      <li key="help" className="desktop-hidden">
        <a href="https://help.justpark.com">Help</a>
      </li>,
      <li key="downloadapp" className="desktop-hidden">
        <a href="https://justpark.onelink.me/3963458492?c=website-homepage&af_dp=justpark://download-app">
          Download our app
        </a>
      </li>,
      <li key="rentoutdriveway" className="desktop-hidden">
        <LegacyLink to="rent-out-a-parking-space/">
          Rent out your driveway
        </LegacyLink>
      </li>,
      <li key="managespaces" className="mobile-hidden">
        <LegacyLink to="dashboard/parking-spaces">Manage my spaces</LegacyLink>
      </li>,
      <li key="billing" className="mobile-hidden">
        <LegacyLink to="dashboard/billing">Billing</LegacyLink>
      </li>,
      <li key="invitefriends" className="mobile-hidden">
        <LegacyLink to="dashboard/refer-a-friend">Invite friends</LegacyLink>
      </li>,
      <li key="logout">
        <LegacyLink to="auth/logout">Log out</LegacyLink>
      </li>
    ]}
    {!user && [
      <li key="howitworks" className="desktop-hidden">
        <LegacyLink to="about/how-it-works">How it works</LegacyLink>
      </li>,
      <li key="help" className="desktop-hidden">
        <a href="https://help.justpark.com">Help</a>
      </li>,
      <li key="download" className="desktop-hidden">
        <LegacyLink to="redirect/app-download">Download our app</LegacyLink>
      </li>,
      <li key="rentspace" className="desktop-hidden">
        <LegacyLink to="rent-out-a-parking-space/">
          Rent out your driveway
        </LegacyLink>
      </li>
    ]}
  </ul>
);

SecondaryNav.defaultProps = {
  user: false
};

SecondaryNav.propTypes = {
  secondaryClass: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
};

const tertiaryNavLinks = [
  {
    url: 'about/how-it-works/',
    text: 'How it works',
    activeKey: 'how-it-works'
  },
  { url: 'about/jobs/', text: 'Jobs', activeKey: 'jobs' },
  {
    url: 'about/media-coverage/',
    text: 'Media Coverage',
    activeKey: 'media-coverage'
  },
  { url: 'about/awards/', text: 'Awards', activeKey: 'awards' }
];

const TertiaryNav = ({ location }) => (
  <div className="c-header__menu-container--tertiary">
    <ul className="c-header__menu c-header__menu--tertiary">
      {tertiaryNavLinks.map((elem, i) => (
        <li
          key={i}
          className={
            location &&
            location.search &&
            location.search.includes(elem.activeKey)
              ? 'is-active'
              : ''
          }
        >
          <LegacyLink to={elem.url}>
            <span>{elem.text}</span>
          </LegacyLink>
        </li>
      ))}
    </ul>
  </div>
);

export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileVisible: false,
      secondaryVisible: false
    };
  }

  toggleMobileMenu() {
    const { mobileVisible } = this.state;
    this.setState({ mobileVisible: !mobileVisible });
  }

  toggleSecondary(e) {
    if (window && window.innerWidth >= 860) {
      const { secondaryVisible } = this.state;
      e.preventDefault();
      this.setState({ secondaryVisible: !secondaryVisible });
    }
  }

  render() {
    const menuContainerClass = this.state.mobileVisible ? '--visible' : '';
    const secondaryClass = `c-header__menu${
      this.state.secondaryVisible ? ' c-header__menu--visible' : ''
    }`;
    const userMenuClass = this.props.user
      ? ''
      : ' c-header__menu--user-no-auth';
    const isAdmin = !!(this.props.user && this.props.user.isAdmin);

    let tertiaryNavigation;
    let headerClass = 'c-header';
    let showSearchLink = false;

    if (
      this.props.location &&
      this.props.location.search &&
      this.props.location.search.includes('showTertiaryNavigation')
    ) {
      tertiaryNavigation = (
        <div className="c-header__row">
          <TertiaryNav location={this.props.location} />
        </div>
      );

      showSearchLink = true;
      headerClass = `${headerClass} ${headerClass}--has-tertiary`;
    }

    return (
      <header className={headerClass}>
        {this.state.mobileVisible && <ScrollLock />}
        <div className="c-header__row">
          <div className="c-header__logo">
            <Link to="/">
              <img src={Logo} alt="JustPark" />
            </Link>
          </div>
          <label
            className="c-header__mobile-anchor"
            onClick={this.toggleMobileMenu.bind(this)}
          />
          {(() => {
            let className = 'c-header__cta';

            if (this.props.ui.headerShouldShowCTA) {
              className = `${className} ${className}--visible`;
            }

            return (
              <div className={className}>
                <button
                  type="button"
                  onClick={() => {
                    this.props.updateUI({
                      headerShouldShowCTA: false,
                      animateSearchForm: true
                    });
                    window.scroll(0, 0);
                    this.props.analytics.track('header-search-cta-clicked');
                  }}
                >
                  <span>Find parking</span>
                </button>
              </div>
            );
          })()}
          <div
            className={`c-header__menu-container c-header__menu-container${menuContainerClass}`}
          >
            <div className="c-header__logo-small">
              <img src={LogoSmall} alt="JustPark" />
            </div>
            <div className="c-header__mobile-scroll">
              {(() => {
                if (__CLIENT__ && window.innerWidth < 780) {
                  return (
                    <GeminiScrollbar>
                      <PrimaryNav showSearchLink={showSearchLink} />
                      <SecondaryNav
                        secondaryClass={secondaryClass}
                        isAdmin={isAdmin}
                        user={this.props.user}
                      />
                    </GeminiScrollbar>
                  );
                }
                return (
                  <div>
                    <PrimaryNav showSearchLink={showSearchLink} />
                    <SecondaryNav
                      secondaryClass={secondaryClass}
                      isAdmin={isAdmin}
                      user={this.props.user}
                    />
                  </div>
                );
              })()}
            </div>
            <ul
              className={`c-header__menu c-header__menu--user${userMenuClass}`}
            >
              <li>
                {this.props.user && (
                  <LegacyLink
                    to="dashboard/"
                    onClick={this.toggleSecondary.bind(this)}
                  >
                    {this.props.user.unreadMessages > 0 && (
                      <div className="c-header__menu--message-count">
                        {this.props.user.unreadMessages}
                      </div>
                    )}
                    {`${this.props.user.firstName} ${this.props.user.lastName &&
                      this.props.user.lastName.charAt(0).toUpperCase()}`}
                    <ProfileImage imageUrl={this.props.user.profilePhoto} />
                  </LegacyLink>
                )}
                {!this.props.user && (
                  <LegacyLink to="login" className="c-header__menu--login-link">
                    Login
                  </LegacyLink>
                )}
              </li>
              {!this.props.user && [
                <li key="registration">
                  <LegacyLink
                    to="registration"
                    className="c-header__menu--login-link"
                  >
                    Sign up
                  </LegacyLink>
                </li>,
                <li key="profile">
                  <div className="desktop-hidden">
                    <ProfileImage imageUrl="https://www.justpark.com/media/img/misc/avatar-st.png" />
                  </div>
                </li>
              ]}
            </ul>
          </div>
          <div
            className={`c-header__menu-overlay c-header__menu-overlay${menuContainerClass}`}
            onClick={this.toggleMobileMenu.bind(this)}
          />
        </div>
        {tertiaryNavigation}
      </header>
    );
  }
}

Header.defaultProps = {
  user: false,
  ui: {}
};

Header.propTypes = {
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  ui: PropTypes.object,
  location: PropTypes.object
};

Header.defaultProps = {
  user: undefined,
  ui: {},
  location: undefined
};

export default compose(
  withRouter,
  withAnalytics({}, {}),
  ui()
)(Header);
